import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { pageview } from "../functions/gtm";
import useIsClient from "@/hooks/useIsClient";
import useShouldFire from "./useShouldFire";

export default function useGoogleTagManager(
  google_tag: string,
  refresh?: boolean,
) {
  const pathname = usePathname();
  const isClient = useIsClient();
  const shouldFire = useShouldFire();
  useEffect(() => {
    if (!isClient || !google_tag || !shouldFire) return;
    pageview(pathname);
  }, [pathname, isClient, google_tag, refresh, shouldFire]);
}
